// extracted by mini-css-extract-plugin
export var body = "CqcRating-module--body--a260a";
export var logo = "CqcRating-module--logo--019f5";
export var rating = "CqcRating-module--rating--00d67";
export var themeGood = "CqcRating-module--themeGood--d517d";
export var themeInadequate = "CqcRating-module--themeInadequate--757aa";
export var themeOutstanding = "CqcRating-module--themeOutstanding--c0f61";
export var themePending = "CqcRating-module--themePending--24a10";
export var themeRequiresImprovement = "CqcRating-module--themeRequiresImprovement--ae5de";